"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentRoute = void 0;
const get_1 = __importDefault(require("lodash/get"));
const router_1 = require("next/router");
const react_1 = require("react");
const libs_router_config_1 = require("@hotelplan/libs.router-config");
function useCurrentRoute() {
    const nextRouter = (0, router_1.useRouter)();
    return (0, react_1.useMemo)(() => {
        const route = (0, libs_router_config_1.getRouteByNextRouter)(nextRouter);
        const { asPath } = nextRouter;
        const [path, query] = asPath.split('?');
        return {
            nextRouter,
            route,
            routeParams: (0, get_1.default)(route === null || route === void 0 ? void 0 : route.matcher(path), `params`, undefined),
            query,
            getAlternative(lang) {
                if (!route)
                    return undefined;
                return (0, libs_router_config_1.getRouteByLangId)(route.id, lang);
            },
        };
    }, [nextRouter]);
}
exports.useCurrentRoute = useCurrentRoute;
//# sourceMappingURL=useCurrentRoute.js.map